import { FC } from 'react';

import { PopularQueriesSkeletonWrapper, QueryButtonSkeleton } from './Skeletons.styles';

export const PopularQueriesSkeleton: FC = () => {
    return (
        <PopularQueriesSkeletonWrapper>
            <QueryButtonSkeleton />
            <QueryButtonSkeleton />
        </PopularQueriesSkeletonWrapper>
    );
};
